import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';
import CountUp from '@/components/base/CountUp';

export default function BrandOverview() {
  return (
    <section className="relative w-full bg-background-950 py-20 md:py-28 overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500/[0.02] rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-10 left-10 w-64 h-64 bg-accent-500/[0.015] rounded-full blur-3xl pointer-events-none"></div>

      <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
        <div className="max-w-screen-2xl mx-auto">
          <ScrollReveal>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-8">
              <span className="w-1 h-1 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-accent-300 text-xs font-medium tracking-wider whitespace-nowrap">
                冯全普·县域AI+OPC联盟核心成员单位
              </span>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <ScrollReveal>
                <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 mb-8 leading-tight">
                  立足三晋华夏文明沃土<br />
                  以<span className="text-primary-500 relative inline-block">
                    AI技术
                    <span className="absolute -bottom-1 left-0 w-full h-[2px] bg-gradient-to-r from-primary-500/0 via-primary-500/60 to-primary-500/0"></span>
                  </span>为核心驱动力
                </h2>

                <div className="space-y-4 text-secondary-300 text-base leading-relaxed">
                  <p>
                    晋铧叙梦（山西）文化科技有限公司，立足三晋华夏文明沃土，以AI技术为核心驱动力，专注地域文化数字资产重构与运营。公司首创
                    <strong className="text-foreground-100 font-medium">县域文化数字化全链路商业闭环</strong>
                    ，依托自研AI工业化生产平台，实现文化资源数字化采集、AI内容量产、全渠道分发变现的标准化落地。
                  </p>
                  <p>
                    作为冯全普·县域AI+OPC联盟核心成员单位，晋铧叙梦深度融入联盟“超级个体+AI工具+OPC社区+敏捷供应链+商业项目”的县域数字经济协作生态，以山西为样板，辐射全国，致力成为中国文化数字化领域的标杆企业与生态领跑者。
                  </p>
                </div>

                <Link
                  to="/about"
                  className="group inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-500 text-background-950 font-medium rounded-full text-sm hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-[0_0_30px_rgba(200,160,80,0.2)]"
                >
                  了解更多
                  <span className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>
              </ScrollReveal>
            </div>

            <ScrollReveal>
              <div className="relative group/card">
                <div className="relative rounded-2xl overflow-hidden border border-primary-500/15 transition-all duration-700 group-hover/card:border-primary-500/30 group-hover/card:shadow-[0_0_60px_rgba(200,160,80,0.08)]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Shanxi%20ancient%20architecture%20pagoda%20and%20courtyard%20silhouette%20with%20warm%20golden%20light%2C%20dark%20moody%20background%2C%20digital%20data%20visualization%20overlay%2C%20cultural%20heritage%20preservation%20concept%2C%20professional%20corporate%20style%2C%20clean%20composition%2C%20atmospheric%20lighting%2C%20no%20text&width=800&height=600&seq=brand-overview-shanxi-02&orientation=landscape"
                    alt="山西文化数字化"
                    className="w-full h-auto object-cover transition-transform duration-1000 group-hover/card:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 to-transparent"></div>
                </div>

                <div className="absolute -bottom-6 -right-6 bg-background-900 rounded-2xl border border-primary-500/20 p-6 md:p-8 transition-all duration-500 group-hover/card:-translate-y-2 group-hover/card:border-primary-500/35 group-hover/card:shadow-[0_20px_60px_rgba(0,0,0,0.4)]">
                  <div className="font-heading text-primary-500 text-6xl md:text-7xl font-bold leading-none">
                    <CountUp end={117} duration={2200} />
                  </div>
                  <p className="text-secondary-300 text-sm mt-2">
                    山西县域文化数字资产库<br />1.0已建成
                  </p>
                  <Link
                    to="/business"
                    className="group inline-flex items-center gap-1.5 mt-3 text-xs text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    探索数字资产库
                    <span className="w-3 h-3 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5">
                      <i className="ri-arrow-right-up-line"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}
